import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

/**
 * BreastfeedingForm — add a breastfeeding session.
 *
 * Props:
 *   onAdd          — called with the new entry object
 *   initialValues  — optional pre-fill from a stopped timer:
 *                    { date, duration }
 */
const BreastfeedingForm = ({ onAdd, initialValues }) => {
  const [date, setDate]         = useState(() => initialValues?.date     || toDatetimeLocal());
  const [side, setSide]         = useState("left");
  const [duration, setDuration] = useState(() => initialValues?.duration != null ? String(initialValues.duration) : "");
  const [notes, setNotes]       = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!duration) return;
    onAdd({
      date:     new Date(date).toISOString(),
      side,
      duration: parseFloat(duration),
      notes,
    });
    setDate(toDatetimeLocal());
    setSide("left");
    setDuration("");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2 mb-2">
        <div className="col-12">
          <label className="form-label">Date &amp; Time</label>
          <input
            type="datetime-local"
            className="form-control form-control-sm"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
      </div>

      <div className="row g-2 mb-2">
        <div className="col-6">
          <label className="form-label">Side</label>
          <select
            className="form-select form-select-sm"
            value={side}
            onChange={(e) => setSide(e.target.value)}
          >
            <option value="left">Left</option>
            <option value="right">Right</option>
            <option value="both">Both</option>
          </select>
        </div>
        <div className="col-6">
          <label className="form-label">Duration (min)</label>
          <input
            type="number"
            className="form-control form-control-sm"
            placeholder="e.g. 15"
            min="1"
            step="1"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
            required
          />
        </div>
      </div>

      <div className="row g-2 mb-2">
        <div className="col-12">
          <label className="form-label">Notes <span style={{ color: "var(--text-light)", fontSize: "0.8rem" }}>(optional)</span></label>
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Any notes..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
      </div>

      <button type="submit" className="btn btn-primary btn-sm w-100">
        + Log Feed
      </button>
    </form>
  );
};

export default BreastfeedingForm;
